import '@hems/component/resources/scss/main.scss';
import { defineComponent, reactive, computed, ref } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import SmartModuleMobileHomeContainer from '@hems/container/src/forms/device/smartmodule/home/SmartModuleMobileHomeContainer.vue';
import { ContainerTitle, MainTitle, VCalendarWrapper } from '@/components';
export default defineComponent({
    name: 'ACModule',
    components: {
        MainTitle,
        ContainerTitle,
        SmartModuleMobileHomeContainer,
        VCalendarWrapper,
    },
    setup() {
        const store = useStore();
        const siteId = computed(() => store.state.device.baseDeviceInfo?.site_id);
        const MAPPER_CONTAINER_WIDTH = 796;
        const MAPPER_CONTAINER_HEIGHT = 570;
        const today = new Date();
        const state = reactive({
            show: true,
            date: new Date(),
            isOpenCalendar: false,
            calendarMode: 'day',
        });
        const openAndSetWebCalendarMode = (calendarMode) => {
            state.isOpenCalendar = true;
            state.calendarMode = calendarMode;
        };
        const closeWebCalendar = () => {
            state.isOpenCalendar = false;
        };
        const selectedDate = ref('');
        const changeViewTab = () => {
            selectedDate.value = '';
            state.date = new Date();
        };
        const getUpdatedDate = (updatedDate) => {
            const formatUpdatedDate = moment(updatedDate).format('YYYYMMDD');
            if (state.calendarMode === 'day') {
                selectedDate.value = formatUpdatedDate;
            }
            else if (state.calendarMode === 'month') {
                selectedDate.value = formatUpdatedDate.substring(0, 6);
            }
            else if (state.calendarMode === 'year') {
                selectedDate.value = formatUpdatedDate.substring(0, 4);
            }
        };
        return {
            state,
            openAndSetWebCalendarMode,
            closeWebCalendar,
            getUpdatedDate,
            changeViewTab,
            today,
            siteId,
            MAPPER_CONTAINER_WIDTH,
            MAPPER_CONTAINER_HEIGHT,
            selectedDate,
        };
    },
});
